import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import { isEmpty, uniqueId } from 'lodash';
import moment from 'moment';
import { styled } from '@mui/system';
import { convertMoney } from '@/utils/convertMoney';
import { style } from '@/styles/globals';
import airportVn from '@/mappings/airport_vn.json';
import { Box } from '@mui/material';
import { pr } from '@/utils/pxToRem';
import WideTableCell from '@/components/WideTableCell';
import FlexTableRow from '@/components/FlexTableRow';
import ShowNoDataDescription from '@/components/ShowNoDataDescription';

const CTABooking = styled('div')`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color:${style.color.product3};
`;
const StyledFlexTableRow = styled(FlexTableRow)`
  &:nth-of-type(odd) {
    background-color: ${style.color.white3};
  }
`;

export default function TableFare({
  flightData, selectedDate, onSelectTrip, airline, hideAirline,
}: any) {
  const date = moment(selectedDate).format('YYYY-MM-DD');
  let data = flightData ? flightData[date] : [];

  if (airline && !isEmpty(data)) {
    data = data.filter((d: any) => d.airline.code === airline);
  }

  return (
    <TableContainer
      component={Paper}
      sx={{
        minHeight: '50px',
        boxShadow: 'none',
      }}
    >
      <Table
        sx={{ }}
        aria-label="simple table"
      >
        <TableHead>
          <FlexTableRow sx={{ background: 'white' }}>
            <WideTableCell
              align="center"
            >
              Hành trình
            </WideTableCell>
            <WideTableCell
              sx={{ whiteSpace: 'nowrap' }}
              align="center"
            >
              Giá rẻ nhất
            </WideTableCell>
          </FlexTableRow>
        </TableHead>
        <TableBody>
          {!isEmpty(data) ? data.slice(0, 6)?.map((row: any) => {
            const idParts = row.id.split('|');
            let fromLocation = '';
            let toLocation = '';
            airportVn.airports.forEach((ap) => {
              if (ap.VxrAreaId === +idParts[6]) {
                fromLocation = ap.CityName_Vi;
              } else if (ap.VxrAreaId === +idParts[7]) {
                toLocation = ap.CityName_Vi;
              }
            });
            return (
              <StyledFlexTableRow
                key={uniqueId()}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <WideTableCell>
                  <CTABooking
                    onClick={() => onSelectTrip(row)}
                    style={{
                      textAlign: 'left',
                      textDecoration: 'underline',
                    }}
                  >
                    {`Vé máy bay${!hideAirline ? ` ${row.airline.name}` : ''} từ ${fromLocation} đi ${toLocation}`}
                  </CTABooking>
                </WideTableCell>
                <WideTableCell align="center">
                  <div>
                    {convertMoney(row.total_price_adult)}
                  </div>
                  <CTABooking onClick={() => onSelectTrip(row)}>
                    Đặt vé
                  </CTABooking>
                </WideTableCell>
              </StyledFlexTableRow>
            );
          }) : <Box sx={{ p: pr`16px` }}><ShowNoDataDescription /></Box>}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
